/**
 * Cómo se llega al organigrama, y a dónde se vuelve.
 *
 * Aparte del lienzo a propósito: lo importan Áreas de la empresa y Panorama para
 * armar su botón, y si viviera junto al editor arrastraría React Flow al paquete
 * principal del portal, que es justo lo que la carga diferida evita.
 */

export interface OrgChartBack {
  readonly path: string;
  readonly label: string;
}

export const orgChartPath = (areaId: string): string => `/organigrama/${areaId}`;

/**
 * Lo que viaja en el estado de la navegación: de qué pantalla se vino.
 *
 * El «← volver» del organigrama decía siempre «Áreas de la empresa», y desde
 * que se entra también desde el Panorama eso llevaba a otra pantalla que la que
 * se dejó.
 */
export const orgChartState = (back: OrgChartBack): { readonly orgChartBack: OrgChartBack } => ({
  orgChartBack: back,
});

/**
 * El «volver» que traía la navegación, o `null`.
 *
 * El estado del historial lo puede escribir cualquiera —otra pestaña, una
 * extensión— así que se lee con cuidado: sólo rutas del propio portal, nunca
 * `//otro-sitio` ni `https://…`.
 */
export const readOrgChartBack = (state: unknown): OrgChartBack | null => {
  if (typeof state !== 'object' || state === null || !('orgChartBack' in state)) return null;
  const back = state.orgChartBack;
  if (typeof back !== 'object' || back === null) return null;
  if (!('path' in back) || !('label' in back)) return null;
  const { path, label } = back;
  if (typeof path !== 'string' || typeof label !== 'string' || label.trim().length === 0) {
    return null;
  }
  if (!path.startsWith('/') || path.startsWith('//')) return null;
  return { path, label };
};
